import {
  DashboardOutlined,
  DirectionsCarOutlined,
  GroupOutlined,
  HubOutlined,
  AssessmentOutlined,
  AccountBalanceWalletOutlined,
  NotificationsNoneOutlined,
  SettingsOutlined,
  LogoutOutlined,
  ApartmentOutlined,
} from "@mui/icons-material";

// Icons
const list = [
  {
    name: "Dashboard",
   for:["USER"],
    icon: DashboardOutlined,
    isCollapsible: false,
    open: false,
    src: "/assets/images/sidebar_icons_2.0/Dashboard.png",
    link: "/dashboard-client",
    active: false,
  },
  {
    name: "Mes reservations",
   for:["USER"],
    icon: DashboardOutlined,
    isCollapsible: false,
    open: false,
    src: "/assets/images/sidebar_icons_2.0/Dashboard.png",
    link: "/trajet",
    active: false,
  },
  {
  name: "Mes trajets",
   for:["USER"],
    icon: DashboardOutlined,
    isCollapsible: false,
    open: false,
    src: "/assets/images/sidebar_icons_2.0/Dashboard.png",
    link: "/trajet-client",
    active: false,
  },
  {
    name: "Historiques",
     for:["USER"],
      icon: DashboardOutlined,
      isCollapsible: false,
      open: false,
      src: "/assets/images/sidebar_icons_2.0/Dashboard.png",
      link: "/historique-client",
      active: false,
    },
    {
      name: "Mes paiements",
       for:["USER"],
        icon: DashboardOutlined,
        isCollapsible: false,
        open: false,
        src: "/assets/images/sidebar_icons_2.0/Dashboard.png",
        link: "/paiements-client",
        active: false,
      },
      {
        name: "Wallet",
         for:["USER"],
          icon: DashboardOutlined,
          isCollapsible: false,
          open: false,
          src: "/assets/images/sidebar_icons_2.0/Dashboard.png",
          link: "/wallet-client",
          active: false,
        },
        {
          name: "Favoris",
           for:["USER"],
            icon: DashboardOutlined,
            isCollapsible: false,
            open: false,
            src: "/assets/images/sidebar_icons_2.0/Dashboard.png",
            link: "/favoris-client",
            active: false,
          },
          {
          name: "Profil",
           for:["USER"],
            icon: DashboardOutlined,
            isCollapsible: false,
            open: false,
            src: "/assets/images/sidebar_icons_2.0/Dashboard.png",
            link: "/profile-client",
            active: false,
          },
          {
            name: "Parametres",
             for:["USER"],
              icon: DashboardOutlined,
              isCollapsible: false,
              open: false,
              src: "/assets/images/sidebar_icons_2.0/Dashboard.png",
              link: "/settings-client",
              active: false,
            },
  {
    name: "Gestion reservations",
    for:["USER"],
    isCollapsible: true,
    open: false,
    src: "/assets/images/sidebar_icons_2.0/Member.png",
    active: false,
    subMenu: [
      { name: "Place", for:["ADMIN","DISPATCHER","ACCOUNT MANAGER","SUB COMPANY"], src: "/assets/images/sidebar_icons_2.0/Add location.png", subLink: "/place" },
      { name: "Ride", for:["ADMIN","DISPATCHER","ACCOUNT MANAGER","SUB COMPANY"], src: "/assets/images/sidebar_icons_2.0/Drivers.png", subLink: "/ride" },
      { name: "Ride Waypoint", for:["ADMIN","DISPATCHER","ACCOUNT MANAGER","SUB COMPANY"], src: "/assets/images/sidebar_icons_2.0/Zone management.png", subLink: "/ride-waypoint" },
      { name: "Booking", for:["ADMIN","DISPATCHER","ACCOUNT MANAGER","SUB COMPANY"], src: "/assets/images/sidebar_icons_2.0/Passenger.png", subLink: "/booking" },
      { name: "Conversations", for:["ADMIN","DISPATCHER","ACCOUNT MANAGER","SUB COMPANY"], src: "/assets/images/sidebar_icons_2.0/Notification.png", subLink: "/conversations" },
      { name: "Messages", for:["ADMIN","DISPATCHER","ACCOUNT MANAGER","SUB COMPANY"], src: "/assets/images/sidebar_icons_2.0/Notification.png", subLink: "/messages" },
      { name: "Reviews", for:["ADMIN","DISPATCHER","ACCOUNT MANAGER","SUB COMPANY"], src: "/assets/images/sidebar_icons_2.0/User Ratings.png", subLink: "/reviews" },
      { name: "Bus Routes", for:["ADMIN","DISPATCHER","ACCOUNT MANAGER","SUB COMPANY"], src: "/assets/images/sidebar_icons_2.0/Zone management.png", subLink: "/bus-routes" },
      { name: "Bus Trip", for:["ADMIN","DISPATCHER","ACCOUNT MANAGER","SUB COMPANY"], src: "/assets/images/sidebar_icons_2.0/Report.png", subLink: "/bus-trip" },
    ],
  },
  {
    name: "Fleet Management",
    for:["ADMIN","DISPATCHER","SUB COMPANY"],
    isCollapsible: true,
    open: false,
    src: "/assets/images/sidebar_icons_2.0/Member.png",
    active: false,
    subMenu: [
      { name: "Vehicle", for:["ADMIN","DISPATCHER","SUB COMPANY"] ,/*icon: SensorOccupied,*/   src: "/assets/images/sidebar_icons/CarAccessories.png", subLink: "/vehicle" },
      { name: "Driver", for:["ADMIN","DISPATCHER","SUB COMPANY"] ,/*icon: SensorOccupied,*/   src: "/assets/images/sidebar_icons_2.0/Drivers.png", subLink: "/driver" },
      { name: "Dispatcher", for:["ADMIN"],/*icon: SupportAgent,*/  src: "/assets/images/sidebar_icons_2.0/Dispatcher.png" , subLink: "/dispatcher" },
      { name: "Sub Company", for:["ADMIN"], /*icon: MeetingRoom ,*/  src: "/assets/images/sidebar_icons_2.0/Sub-company.png", subLink: "/sub-company" }
    ],
  },
  {
    name: "User Management",
    for:["ADMIN","DISPATCHER"],
    isCollapsible: true,
    open: false,
    src: "/assets/images/sidebar_icons_2.0/Member.png",
    active: false,
    subMenu: [
      { name: "Passenger", for:["ADMIN","DISPATCHER"], /*icon: Hail,*/  src: "/assets/images/sidebar_icons_2.0/Passenger.png", subLink: "/passenger" },
      { name: "Account Manager", for:["ADMIN"], /*icon: AdminPanelSettings ,*/  src: "/assets/images/sidebar_icons_2.0/Account Manager.png", subLink: "/account-manager" },
      { name: "Corporate", for:["ADMIN"], /*icon: CorporateFare ,*/ src: "/assets/images/sidebar_icons_2.0/Corporate.png", subLink: "/corporate" },
      { name: "Hotel/Restaruant", for:["ADMIN"], /*icon: Luggage ,*/  src: "/assets/images/sidebar_icons_2.0/Hotel.png", subLink: "/hotel" },
    ],
  },

  {
    name: "Operations",
    isCollapsible: true,
    open: false,
    src: "/assets/images/sidebar_icons_2.0/Zone management.png",
    for:["ADMIN"],
    active: false,
    subMenu: [
      { name: "Service Type", for:["ADMIN"], src: "/assets/images/sidebar_icons_2.0/Services Type.png", subLink: "/servicetype" },
      { name: "Add Location", for:["ADMIN"], src: "/assets/images/sidebar_icons_2.0/Add location.png", subLink: "/add-location" },
      { name: "List Location", for:["ADMIN"], src: "/assets/images/sidebar_icons_2.0/LIst location.png", subLink: "/list-location" },
      { name: "Restrict Location", for:["ADMIN"], src: "/assets/images/sidebar_icons_2.0/Restrictlocation.png", subLink: "/restrict-location" },
      { name: "Service Type Fare", for:["ADMIN"], src: "/assets/images/sidebar_icons_2.0/Service Type Fare.png", subLink: "/servicetypefare" },
      { name: "Zone Wise Fare", for:["ADMIN"], src: "/assets/images/sidebar_icons_2.0/Zone management.png", subLink: "/ServicetypeZonefare" },
    ],
  },
  {
    name: "Reports",
    isCollapsible: true,
    open: false,
    src: "/assets/images/sidebar_icons_2.0/Report.png",
    for:["ADMIN","ACCOUNT MANAGER"],
    active: false,
    subMenu: [
      { name: "Overall Ride Statements", for:["ADMIN","ACCOUNT MANAGER"], src: "/assets/images/sidebar_icons_2.0/Over all Statement.png", subLink: "/overallreport" },
      { name: "Driver Statement", for:["ADMIN","ACCOUNT MANAGER"], src: "/assets/images/sidebar_icons_2.0/driver Statement.png", subLink: "/driversreport" },
      { name: "Km Driven / Duration", for:["ADMIN","ACCOUNT MANAGER"], src: "/assets/images/sidebar_icons_2.0/Driver Account Statement.png", subLink: "/kmdriven-duration-report" },
    ],
  },
  {
    name: "Finance",
   for:["ADMIN"],
    isCollapsible: true,
    open: false,
    src: "/assets/images/sidebar_icons_2.0/Earning and reward.png",
    active: false,
    subMenu: [
      { name: "Driver Earnings", for:["ADMIN"], /*icon: AccountBalanceWallet ,*/  src: "/assets/images/sidebar_icons_2.0/Driver Earnings.png", subLink: "/driver-earnings" },
      { name: "Driver Pending Cashouts", for:["ADMIN"], /*icon: AccountBalanceWallet ,*/  src: "/assets/images/sidebar_icons_2.0/Cashout Record.png", subLink: "/cashoutrecords" },
      { name: "Driver Approved Cashouts", for:["ADMIN"], /*icon: AccountBalanceWallet ,*/  src: "/assets/images/sidebar_icons_2.0/Cashout Record.png", subLink: "/cashoutsapproved" },
      { name: "Driver Rejected Cashouts", for:["ADMIN"], /*icon: AccountBalanceWallet ,*/  src: "/assets/images/sidebar_icons_2.0/Cashout Record.png", subLink: "/cashoutsrejected" },
      { name: "Users Wallet", for:["ADMIN"], src: "/assets/images/sidebar_icons_2.0/User Reward.png", subLink: "/user-wallet" },
      { name: "Banks Available", for:["ADMIN"], src: "/assets/images/sidebar_icons_2.0/Bank available.png", subLink: "/available_banks" },
      { name: "Account type Settings", for:["ADMIN"], src: "/assets/images/sidebar_icons_2.0/Account type setting.png", subLink: "/account-type-settings" },
    ],
  },
  {
    name: "Engagement",
    isCollapsible: true,
    for:["ADMIN"],
    open: false,
    src: "/assets/images/sidebar_icons_2.0/Notification.png",
    active: false,
    subMenu: [
      { name: "User Ratings", for:["ADMIN"], src: "/assets/images/sidebar_icons_2.0/User Ratings.png", subLink: "/userratings" },
      { name: "Driver Ratings", for:["ADMIN"], src: "/assets/images/sidebar_icons_2.0/Driver Rating.png", subLink: "/driverratings" },
      { name: "Sms Notification", for:["ADMIN"], src: "/assets/images/sidebar_icons_2.0/SMS Notification.png", subLink: "/smsnotifications" },
      { name: "Mail Notification", for:["ADMIN"], src: "/assets/images/sidebar_icons_2.0/Mail Notification.png", subLink: "/mailnotifications" },
      { name: "Push Notification", for:["ADMIN"], src: "/assets/images/sidebar_icons_2.0/Push Notification.png", subLink: "/pushnotifications" },
      { name: "Promocodes", for:["ADMIN"], /*icon:Key ,*/  src: "/assets/images/sidebar_icons_2.0/Promo code.png", subLink: "/promocodes" },
    ]
  },

  {
    name: "Settings",
    isCollapsible: true,
    for:["ADMIN","DISPATCHER","ACCOUNT MANAGER"],
    // icon: Settings ,
    open: false,
    src: "/assets/images/sidebar_icons_2.0/Setting.png",
    active: false,
    subMenu: [
      { name: "Admin Commission Settings", for:["ADMIN"], /*icon:Password ,*/ src: "/assets/images/sidebar_icons_2.0/Driver platfrom Fee.png", subLink: "/admin-commission-settings" },
     // { name: "Banks Available", for:["ADMIN"], /*icon:Password ,*/ src: "/assets/images/sidebar_icons_2.0/Driver platfrom Fee.png", subLink: "/available_banks" },
      { name: "Banner Template Management", for:["ADMIN"], /*icon: SettingsApplications ,*/  src: "/assets/images/sidebar_icons_2.0/bannerImage.png", subLink: "/BannerTemplateManage" },
      { name: "Site Settings", for:["ADMIN"], /*icon: SettingsApplications ,*/  src: "/assets/images/sidebar_icons_2.0/Site setting.png", subLink: "/site-settings" },
    //  { name: "Payment Settings", for:["ADMIN"], /*icon: Payments ,*/  src: "/assets/images/sidebar_icons_2.0/Payment Settings.png", subLink: "/payment-settings" },
      { name: "Business Settings", for:["ADMIN"], /*icon: BusinessCenter ,*/  src: "/assets/images/sidebar_icons_2.0/Business Settings.png", subLink: "/business-settings" },
      { name: "Foundation", for:["ADMIN"], src: "/assets/images/sidebar_icons_2.0/Setting.png", subLink: "/foundation" },
      { name: "Change Password", for:["ADMIN","DISPATCHER","ACCOUNT MANAGER"], /*icon:Password ,*/ src: "/assets/images/sidebar_icons_2.0/Change Password.png", subLink: "/change-password" },
    // { name: "Legal Settings", for:["ADMIN"], /*icon: Policy,*/  src: "/assets/images/sidebar_icons_2.0/Legal Settings.png", subLink: "/legal-settings" },
    // Make Legal Settings itself collapsible
    { 
      name: "Legal Settings", 
      for:["ADMIN"], 
      isCollapsible: true,
      src: "/assets/images/sidebar_icons_2.0/Legel Setting.png",
      open: false,
      active: false,
      subMenu: [
        { 
          name: "Terms & Conditions", 
          for:["ADMIN"], 
          src: "/assets/images/sidebar_icons_2.0/Terms and conditions.png", 
          subLink: "/terms-conditions" 
        },
        { 
          name: "Privacy Policy", 
          for:["ADMIN"], 
          src: "/assets/images/sidebar_icons_2.0/Privacy policy.png", 
          subLink: "/privacy-policy" 
        }
      ]
    }
    ],
  },

  // {
  //   name: "CMS Settings",
  //  for:["ADMIN"],
  //  icon: AppSettingsAlt ,
  //   isCollapsible: true,
  //   open: false,
  //   src: "/assets/images/sidebar_icons_2.0/CMS Settings.png",
  //   active: false,
  //   subMenu: [
  //     { name: "Trip Notes", for:["ADMIN"], /*icon: AirlineStops ,*/  src: "/assets/images/sidebar_icons_2.0/Trip Notes.png", subLink: "#" },
  //     { name: "Trip Ratings", for:["ADMIN"], /*icon: ThumbsUpDown ,*/  src: "/assets/images/sidebar_icons_2.0/Trip Ratings.png", subLink: "#" },
  //     { name: "Other Contents", for:["ADMIN"], /*icon: Comment ,*/  src: "/assets/images/sidebar_icons_2.0/Other Contents.png", subLink: "#" },
  //   ],
  // },

// for corporate users

  {
    name: "Dashboard",
   for:["CORPORATE"],
    //icon: Dashboard,
    isCollapsible: false,
    open: false,
    src: "/assets/images/sidebar_icons_2.0/Dashboard.png",
    link: "/dashboard_corporate",
    active: false,
  },

  {
    name: "Groups",
   for:["CORPORATE"],
    //icon: Dashboard,
    isCollapsible: false,
    open: false,
    src: "/assets/images/sidebar_icons_2.0/Group.png",
    link: "/corporate_group",
    active: false,
  },
  {
    name: "Employees",
   for:["CORPORATE"],
    //icon: Dashboard,
    isCollapsible: false,
    open: false,
    src: "/assets/images/sidebar_icons_2.0/Employee.png",
    link: "/corporate_employee",
    active: false,
  },

  {
    name: "Reports",
    isCollapsible: true,
    open: false,
    src: "/assets/images/sidebar_icons_2.0/Report.png",
    for:["CORPORATE"],
 // icon: Report, 
    active: false,
    subMenu: [
      { name: "Overall Ride Statements", for:["CORPORATE"], /*icon: Assessment ,*/  src: "/assets/images/sidebar_icons_2.0/Over all Statement.png", subLink: "/overallreport_corp" },
      { name: "Daily Statement", for:["CORPORATE"], /*icon: TextSnippet ,*/  src: "/assets/images/sidebar_icons_2.0/Daily statement.png", subLink: "/dailytripreport_corp" },
      { name: "Monthly Statement", for:["CORPORATE"], /*icon:CalendarMonth ,*/ src: "/assets/images/sidebar_icons_2.0/Monthly statement.png", subLink: "/monthlytripreport_corp" },
      { name: "Yearly Statement", for:["CORPORATE"], /*icon: DateRange ,*/  src: "/assets/images/sidebar_icons_2.0/Yearly statement.png", subLink: "/yearlytripreport_corp" },
],},

  {
    name: "Sign Out",
    for:["ADMIN","DISPATCHER","ACCOUNT MANAGER","SUB COMPANY" ,"CORPORATE"],
    //  icon: ExitToApp,
    isCollapsible: false,
    open: false,
    src: "/assets/images/sidebar_icons_2.0/Sign Out.png",
    link: "#",
    active: false,
  },
];

export default list;
